import type { FeatureRoute } from '../types';
import { SettingsPage } from './settings/SettingsPage';
import { StaffPage } from './staff/StaffPage';
import { SubscriptionPage } from './subscription/SubscriptionPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'settings', element: <SettingsPage /> },
  { path: 'staff', element: <StaffPage /> },
  { path: 'subscription', element: <SubscriptionPage /> },
];
